import '../../css/profil/profil.scss'
import './_option'